// DiscordUnlinkModal Component
// Displays a confirmation dialog when user wants to unlink their Discord account

import React from 'react';
import { RevoltModal, RevoltButton } from '../../../components';
import './DiscordUnlinkModal.css';

export function DiscordUnlinkModal({ isOpen, onClose, onConfirm, discordUser, isUnlinking = false }) {
  const handleConfirm = async () => {
    try {
      await onConfirm();
      onClose();
    } catch (error) {
      // Error handling is done in the parent component
      console.error('Failed to unlink Discord:', error);
    }
  };

  return (
    <RevoltModal
      isOpen={isOpen}
      onClose={onClose}
      title="Unlink Discord Account"
      containerClassName="discord-unlink-modal"
      showCloseButton={false}
    >
      <div className="discord-unlink-content">
        <div className="discord-unlink-icon">
          <i className="fa-solid fa-triangle-exclamation"></i>
        </div>

        <div className="discord-unlink-message">
          <p className="discord-unlink-main-text">
            Are you sure you want to unlink your Discord account?
          </p>
          <p className="discord-unlink-sub-text">
            You will lose access to Discord community features and updates until you link again.
          </p>
        </div>

        {discordUser && (
          <div className="discord-unlink-account-info">
            <div className="discord-unlink-avatar">
              {discordUser.avatar ? (
                <img
                  src={`https://cdn.discordapp.com/avatars/${discordUser.id}/${discordUser.avatar}.png`}
                  alt="Discord Avatar"
                  className="discord-unlink-avatar-image"
                />
              ) : (
                <div className="discord-unlink-avatar-placeholder">
                  {discordUser.username?.charAt(0)?.toUpperCase() || '?'}
                </div>
              )}
            </div>
            <div className="discord-unlink-username">
              {discordUser.username}{discordUser.discriminator && discordUser.discriminator !== '0' ? `#${discordUser.discriminator}` : ''}
            </div>
          </div>
        )}

        <div className="discord-unlink-actions">
          <RevoltButton
            variant="ghost"
            onClick={onClose}
            disabled={isUnlinking}
          >
            Cancel
          </RevoltButton>
          <RevoltButton
            variant="accent"
            onClick={handleConfirm}
            disabled={isUnlinking}
          >
            {isUnlinking ? 'Unlinking...' : 'Unlink Account'}
          </RevoltButton>
        </div>
      </div>
    </RevoltModal>
  );
}